//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Object.js";
import "../Features/Features.FeatureCollection.js";
let d=[[],[[["corner_blend"],"CreateBlendCornerBuilder",{R_:{builder:"Features.BlendCornerBuilder"}},1,0],[["fill_hole"],"CreateFillHoleBuilder",{R_:{builder:"Features.FillHoleBuilder"}},1,0],[["studioSurface"],"CreateStudioSurfaceBuilderEx",{R_:{builder:"Features.StudioSurfaceBuilderEx"}},1,0],[["flattening_and_forming"],"CreateFlatteningAndFormingBuilderEx",{R_:{builder:"Features.FlatteningAndFormingBuilderEx"}},1,0],[["textureImage"],"CreateTextureBuilder",{R_:{builder:"Features.TextureBuilder"}},1,0],[[],"CreateDeleteTextureObjectsData",{R_:{data:"Features.DeleteTextureObjectsData"}},0,0],[["textureImage"],"CreatePunchThroughBuilder",{R_:{builder:"Features.PunchThroughBuilder"}},1,0],[["swept"],"CreateSweptBuilder1",{R_:{builder:"Features.SweptBuilder1"}},1,0],[["through_curves"],"CreateThroughCurvesBuilder1",{R_:{builder:"Features.ThroughCurvesBuilder1"}},1,0],[["studio_surface"],"CreateStudioSurfaceBuilder1",{R_:{builder:"Features.StudioSurfaceBuilder1"}},1,0],[["ruled"],"CreateRuledBuilder1",{R_:{builder:"Features.RuledBuilder1"}},1,0]],[]];
SPLM.Features.FreeformSurfaceCollection = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Features.FreeformSurfaceCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;